import { render, staticRenderFns } from "./LoginBox.vue?vue&type=template&id=32b33b8e&scoped=true"
import script from "./LoginBox.vue?vue&type=script&lang=js"
export * from "./LoginBox.vue?vue&type=script&lang=js"
import style0 from "./LoginBox.vue?vue&type=style&index=0&id=32b33b8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b33b8e",
  null
  
)

export default component.exports